module.exports = __webpack_public_path__ + "static/media/logo_circle.e469f2b4.svg";